import React from "react";
import { EyeOff } from "lucide-react";

const Hide = ({ className = "size-6", onClick }) => (
  <EyeOff className={className} onClick={onClick} />
);

export default Hide;
